import type { ToneOverlay } from "../index.js";

export const overlay: ToneOverlay = {
  "alert.toast.new": "{hazard} in der Nähe. Zur Kenntnis genommen.",
  "alert.toast.escalation": "{hazard} in der Nähe. Jetzt schlimmer.",
  "alert.toast.inPath": "{hazard} auf dem Weg zu dir. Natürlich.",
  "alert.toast.allClear": "Wieder normal bei {place}.",
  "alert.toast.tap": "Details, falls es dich interessiert.",
  "alert.takeover.title": "{hazard}. Das ist der Teil, wo du gehst.",
  "alert.takeover.details": "Die Details",
  "alert.takeover.dismiss": "Zur Kenntnis",
  "now.status.allClear": "Nichts zu melden.",
  "now.status.stayAware": "Augen auf.",
  "now.status.sub.allClear": "Nichts in deinem Radius. Genieß es.",
  "now.activity.empty": "Niemand hat etwas gemeldet. Verdächtig.",
  "onboarding.promise.tagline": "Nachbarn warnen Nachbarn. Revolutionär.",
  "onboarding.promise.continue": "Na gut, los",
  "onboarding.home.browse": "Nur schauen",
  "you.voice.intro": "Wähle, wie direkt du es haben möchtest.",
};
